import { render, staticRenderFns } from "./modal_update_periode.vue?vue&type=template&id=1fb06caa"
import script from "./modal_update_periode.vue?vue&type=script&lang=js"
export * from "./modal_update_periode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports